import type { GroupResponsibleStore } from '@/scopes/account/group-responsible/domain/types'
import { groupResponsibleStore } from '@/scopes/account/group-responsible/infrastructure/store'
import { identity } from 'ramda'
import { useStore } from 'zustand'

export function useGroupResponsibleStore<T, A extends unknown[] = []>(
  selector: (state: GroupResponsibleStore, ...args: A) => T,
  ...args: A
): T {
  const store = useStore(groupResponsibleStore, identity<GroupResponsibleStore>)
  return selector(store, ...args)
}
